// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"1da0a43b","297":"15f47600","350":"73906708","440":"aec75bf4","881":"763e2610","971":"8b5bddd2"}[chunkId] + ".chunk.js";
};